<template>
  <div class="page-container">
    <div class="feedback-container">
      <el-form 
        ref="feedbackForm" 
        :model="feedbackForm" 
        :rules="rules"
        label-width="100px"
        class="feedback-form">
        
        <el-form-item label="设备类别" prop="deviceSort">
          <span class="required-star">*</span>
          <el-select v-model="feedbackForm.deviceSort" placeholder="请选择设备类别" class="form-input">
            <el-option label="Light Maker 530" value="Light Maker 530"></el-option>
            <el-option label="Light Maker 640" value="Light Maker 640"></el-option>
            <!-- 可以根据需要添加更多选项 -->
          </el-select>
        </el-form-item>

        <el-form-item label="反馈种类" prop="feedbackType">
          <span class="required-star">*</span>
          <el-select 
            v-model="feedbackForm.feedbackType"
            placeholder="请选择反馈种类"
            class="form-input">
            <el-option label="设备故障" value="设备故障"></el-option>
            <el-option label="系统问题" value="系统问题"></el-option>
            <el-option label="其他问题" value="其他问题"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="反馈留言" prop="feedbackMessage">
          <span class="required-star">*</span>
          <el-input
            type="textarea"
            v-model="feedbackForm.feedbackMessage"
            :rows="4"
            placeholder="请详细描述您的问题"
            class="form-textarea">
          </el-input>
        </el-form-item>

        <el-form-item label="手机号码" prop="phone">
          <span class="required-star">*</span>
          <el-input 
            v-model="feedbackForm.phone"
            placeholder="请输入您的手机号"
            class="form-input">
          </el-input>
        </el-form-item>

        <el-form-item class="form-buttons">
          <el-button type="primary" @click="submitFeedback" class="submit-btn">提交反馈</el-button>
          <el-button @click="resetForm" class="reset-btn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    // 手机号码验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

    return {
      feedbackForm: {
        deviceSort: '',
        feedbackType: '',
        feedbackMessage: '',
        phone: ''
      },
      // 表单验证规则
      rules: {
        deviceSort: [
          { required: true, message: '请选择设备类别', trigger: 'change' }
        ],
        feedbackType: [
          { required: true, message: '请选择反馈种类', trigger: 'change' }
        ],
        feedbackMessage: [
          { required: true, message: '请输入反馈内容', trigger: 'blur' },
          { min: 10, message: '反馈内容至少10个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      }
    };
  },

  methods: {
    // 提交反馈
    submitFeedback() {
      this.$refs.feedbackForm.validate((valid) => {
        if (valid) {
          // 发送反馈数据到后端
          axios.post('/api/feedbackTable/insert', this.feedbackForm)
            .then(response => {
              if (response.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '反馈提交成功！'
                });
                this.resetForm(); // 提交成功后重置表单
              } else {
                this.$message.error(response.data.msg || '提交失败，请重试');
              }
            })
            .catch(error => {
              console.error('提交反馈失败:', error);
              this.$message.error('提交失败，请重试');
            });
        } else {
          this.$message.warning('请完善表单信息');
          return false;
        }
      });
    },

    // 重置表单
    resetForm() {
      this.$refs.feedbackForm.resetFields();
      this.feedbackForm = {
        deviceSort: '',
        feedbackType: '',
        feedbackMessage: '',
        phone: ''
      };
    }
  }
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background-color: #EBF5FF;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden ;
}

.feedback-container {
  width: 100%;
  max-width: 1557px;
  height: 868px;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.feedback-form {
  width: 100%;
  max-width: 1557px;
  padding: 20px;
}

.el-form-item {
  position: relative;
  margin-bottom: 40px;
}

.el-form-item :deep(.el-form-item__label) {
  color: #333;
  font-size: 16px;
  line-height: 40px;
}

.required-star {
  color: #F56C6C;
  position: absolute;
  left: -15px;
  top: 12px;
  font-size: 16px;
}

.form-input, .form-textarea {
  width: 100%;
  border-radius: 4px;
}

.form-input :deep(.el-input__inner) {
  height: 50px;
  border: 1px solid #DCDFE6;
  background-color: #FFFFFF;
  font-family: Arial, sans-serif;
  padding: 0 15px;
  border-radius: 4px;
  font-size: 16px;
}

.form-textarea :deep(.el-textarea__inner) {
  border: 1px solid #DCDFE6;
  background-color: #FFFFFF;
  font-family: Arial, sans-serif;
  padding: 15px;
  border-radius: 4px;
  font-size: 16px;
  min-height: 150px;
}

.form-buttons {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.submit-btn {
  background-color: #409EFF;
  color: white;
  border: none;
  padding: 15px 50px;
  border-radius: 4px;
  margin-right: 20px;
  font-size: 16px;
}

.reset-btn {
  background-color: #FFFFFF;
  color: #606266;
  border: 1px solid #DCDFE6;
  padding: 15px 50px;
  border-radius: 4px;
  font-size: 16px;
}

/* 响应式设计 */
@media screen and (max-width: 1600px) {
  .feedback-container {
    max-width: 90%;
    height: auto;
    aspect-ratio: 1557 / 868;
  }
}

@media screen and (max-width: 1200px) {
  .feedback-form {
    max-width: 700px;
  }
  
  .el-form-item {
    margin-bottom: 30px;
  }
  
  .form-input :deep(.el-input__inner), .form-textarea :deep(.el-textarea__inner) {
    font-size: 14px;
  }
  
  .form-textarea :deep(.el-textarea__inner) {
    min-height: 120px;
  }
  
  .submit-btn, .reset-btn {
    padding: 12px 40px;
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  .feedback-container {
    padding: 20px;
    height: auto;
    aspect-ratio: auto;
  }
  
  .feedback-form {
    padding: 10px;
  }
  
  .el-form-item {
    margin-bottom: 20px;
  }
  
  .form-buttons {
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
  }
  
  .submit-btn, .reset-btn {
    width: 100%;
    margin: 5px 0;
    padding: 10px 30px;
  }
}
</style>
